import {
  signInWithEmailAndPassword,
  signOut,
  createUserWithEmailAndPassword,
  updateProfile,
  signInAnonymously,
  User
} from 'firebase/auth';
import { auth } from '../firebaseConfig';

// Sign in with email and password
export const signIn = async (email: string, password: string): Promise<User> => {
  const userCredential = await signInWithEmailAndPassword(auth, email, password);
  return userCredential.user;
};

// Sign out
export const logOut = async (): Promise<void> => {
  await signOut(auth);
};

// Create a new admin user (this would typically be done in a secure backend)
export const createAdmin = async (email: string, password: string, displayName: string): Promise<User> => {
  const userCredential = await createUserWithEmailAndPassword(auth, email, password);
  const user = userCredential.user;

  // Set the display name
  await updateProfile(user, { displayName });

  return user;
};

// Get the current user
export const getCurrentUser = (): User | null => {
  return auth.currentUser;
};

// Check if a user is authenticated
export const isAuthenticated = (): boolean => {
  return !!auth.currentUser;
};

// Sign in anonymously (for public operations that require authentication)
export const signInAnonymousUser = async (): Promise<User> => {
  try {
    // Only sign in anonymously if not already signed in
    if (!auth.currentUser) {
      const userCredential = await signInAnonymously(auth);
      return userCredential.user;
    }
    return auth.currentUser;
  } catch (error) {
    console.error('Error signing in anonymously:', error);
    throw error;
  }
};
